var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileVine4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 569,
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#065e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#328e72"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2048") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer",
    display: "inline"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m21.27,153.54c1.41,-26.06 9.15,-83.1 31.69,-109.86c22.54,-26.76 65.49,-47.18 85.92,-23.24c20.42,23.94 -42.96,150 -54.23,202.11c-11.27,52.11 -19.72,193.66 31.69,211.97c51.41,18.31 114.79,-26.06 121.13,-77.46c6.34,-51.41 -45.07,-35.92 -78.17,-65.49c-33.1,-29.58 -30.28,-83.1 -12.68,-150.7c17.61,-67.61 53.52,-121.13 110.56,-116.2c57.04,4.93 33.8,177.46 34.51,250.7c0.7,73.24 16.2,197.89 0.7,223.94c-15.49,26.06 -43.66,53.52 -114.08,54.23c-70.42,0.7 -123.94,-16.9 -135.92,-72.54c-11.97,-55.63 -22.54,-301.41 -21.13,-327.46z",
    fill: "#ff0000",
    fillOpacity: 0.01,
    id: "svg_20",
    stroke: "#f90000",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileVine4);
export default __webpack_public_path__ + "static/media/mobileVine4.b1ec9cab4cd0369ab741b8b4fd31bf80.svg";
export { ForwardRef as ReactComponent };